export default "__VITE_ASSET__DoQAHJCf__"